import { Button, Tooltip } from '@mantine/core';
import { useCallback } from 'react';

import { GoBack } from '@apple/assets/icons';
import { useTranslation } from '@apple/lib/i18next';
import { useRouterHistory } from '@apple/lib/tanstack-router/hooks/use-router-history';

export type GoBackButtonProps = {
	text?: string;
	variant?: 'default' | 'icon';
};

export function GoBackButton({ text, variant = 'default' }: GoBackButtonProps) {
	const { t } = useTranslation('common');
	const history = useRouterHistory();

	const handleGoBack = useCallback(() => {
		history.back();
	}, [history]);

	if (variant === 'icon') {
		return (
			<Tooltip label={text ?? t('buttons.goBack')} position='top'>
				<GoBack
					disabled={!history.canGoBack()}
					onClick={handleGoBack}
					variant='transparent'
					c='var(--mantine-color-dark-light-color)'
					size={24}
					data-testid='go-back-icon-button'
				/>
			</Tooltip>
		);
	}

	return (
		<Button
			onClick={handleGoBack}
			mb='xs'
			variant='light'
			leftSection={<GoBack size={24} />}
			children={text ?? t('buttons.goBack')}
		/>
	);
}
